import { Container, Sprite } from 'pixi.js';
import type { SceneLayout } from '../scene/layout';
import type { SceneTextures } from '../scene/main-scene';

export interface SpawnedEnemy {
  id: number;
  sprite: Sprite;
  row: number;
  col: number;
}

export function spawnEnemies(
  parent: Container,
  textures: SceneTextures,
  layout: SceneLayout,
  startId = 0,
): SpawnedEnemy[] {
  return layout.enemies.map((item, i) => {
    const tex = textures[item.textureKey];
    if (!tex) throw new Error(`Missing texture: ${item.textureKey}`);
    const sprite = new Sprite(tex);
    sprite.label = `enemy-${item.row}-${item.col}`;
    sprite.x = item.x;
    sprite.y = item.y;
    sprite.scale.set(item.scale);
    sprite.tint = item.tint;
    parent.addChild(sprite);
    return { id: startId + i, sprite, row: item.row, col: item.col };
  });
}
